export default __webpack_public_path__ + "static/char-s-09-cht-1d5dc730ad168adc3cdb6f6a259c6e7c.webp";